import { ReactNode } from 'react';
import './AccountInfoBox.css';

type AccountInfoBoxProps = {
	children: ReactNode;
};

export const AccountInfoBox = ({ children }: AccountInfoBoxProps): JSX.Element => {
	return <div className="account-info">{children}</div>;
};
